import React, { FC, useContext, useMemo } from 'react';
import Radio, { Props as RadioProps } from './Inputs/Radio';
import TitleList from './TitleList';

type ContextType = {
  name: string;
  value?: string | null;
  readOnly?: boolean;
};
export const FormRadioGroupContext = React.createContext({} as ContextType);
const { Provider } = FormRadioGroupContext;

type FormRadioGroupProps = {
  title: string;
  name: string;
  value?: string | null;
  readOnly?: boolean;
};
export const FormRadioGroup: FC<FormRadioGroupProps> = ({
  title,
  name,
  value,
  readOnly,
  children,
}) => {
  const providerValue = useMemo(
    () => ({
      name,
      value,
      readOnly,
    }),
    [name, value, readOnly],
  );
  return (
    <Provider value={providerValue}>
      <TitleList title={title}>
        <div>{children}</div>
      </TitleList>
    </Provider>
  );
};

type FormRadioProps = {
  id: string;
  label: string;
} & RadioProps;
export const FormRadio: FC<FormRadioProps> = ({ id, label, ...props }) => {
  const { name, value, readOnly } = useContext(FormRadioGroupContext);
  return (
    <div>
      <Radio
        id={id}
        name={name}
        label={label}
        checked={value === id}
        readOnly={readOnly}
        {...props}
      />
    </div>
  );
};
